(function($) {
    'use strict';

    /**
     * Сравнение команд
     * @returns {jQuery}
     */
    $.fn.teamsComparison = function () {
        const $self = $(this);
        const $chooseRival = $self.find('.js-choose-rival-team');
        const $holder = $chooseRival.find('.js-value-holder');
        const $textInHolder = $holder.find('.js-text');
        const $teams = $self.find('.js-team-comparison')
        const $teamsList = $self.find('.js-teams-list')
        const $firstTeam = $teams.first();
        const $rivalImg = $self.find('.js-rival-img');
        const $overlay = $self.find('.js-overlay');
        const $closeOverlayBtn = $self.find('.js-close');

        let ps = null;

        /**
         * Инициализировать обработчики событий
         */
        const initEvents = () => {
            $holder.on('click', function() {
                $chooseRival.toggleClass('opened');
                $overlay.toggleClass('active');

                if (SVK.checkBreakpoint() === 'mobile') {
                    SVK.makeFixedHtml();
                }
            });

            $closeOverlayBtn.on('click', function () {
                SVK.makeUnfixedHtml();
                $chooseRival.toggleClass('opened');
                $overlay.removeClass('active');
            });

            $chooseRival.on('click', '.js-team-comparison', function(e) {
                e.preventDefault();
                $teams.removeClass('active');
                $(this).addClass('active');
                const name = $(this).find('.js-name').text();
                const src = $(this).find('.js-img').attr('src');
                setRivalTeam(name, src);
                $chooseRival.removeClass('opened');
                $overlay.removeClass('active');
                SVK.makeUnfixedHtml();
            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.js-choose-rival-team').length) {
                    $chooseRival.removeClass('opened');
                }
            })
        }

        /**
         * Установить команду соперника
         * @param {String} name
         * @param {String} src
         */
        const setRivalTeam = (name,src) => {
            $textInHolder.text(name);
            $rivalImg.attr('alt', name);
            $rivalImg.attr('src', src);
        }

        /**
         * Инициализация
         */
        const init = () => {
            initEvents();
            $firstTeam.addClass('active');
            setRivalTeam($firstTeam.find('.js-name').text(), $firstTeam.find('.js-img').attr('src'));

            if (typeof PerfectScrollbar !== 'undefined' && ps === null) {
                new PerfectScrollbar($teamsList.get(0), {
                    suppressScrollX: true
                });
            }
        };

        init();

        return this;
    };
})(jQuery);
